// export let BASE_URL = 'http://localhost:3001'
// export let BASE_URL = 'https://wovvmapsitapi.wovvtech.com'
import React from 'react'
import { useLocation } from 'react-router-dom'
export let BASE_URL;
function ConfigReact() {
    let location = useLocation()
    console.log(location.pathname, "location");
    if (location.pathname === "/sit") {
        BASE_URL = 'https://wovvmapsitapi.wovvtech.com'
    } else if (location.pathname === "/pro") {
        BASE_URL = 'https://wovvmapapi.wovvtech.com'
    } else {
        // defalt sit api lega 
        BASE_URL = 'https://wovvmapsitapi.wovvtech.com'
    }
    return (
        <div></div>
    )
}

export default ConfigReact

